import { useState } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router';
import { Toaster } from 'sonner';

import { AuthProvider } from '@/auth/AuthProvider';
import { routes } from '@/routes';

function makeQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30 * 1000,
        refetchOnWindowFocus: false,
      },
    },
  });
}

function RootShell() {
  return (
    <AuthProvider>
      <Outlet />
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}

const router = createBrowserRouter([
  {
    element: <RootShell />,
    children: routes,
  },
]);

export function App() {
  const [queryClient] = useState(makeQueryClient);
  return (
    <QueryClientProvider client={queryClient}>
      {/* De RuitID-poll-provider (S014.4) hing hier, boven de router. Sinds S021.5b
          (EPIC-021, deel A) hangt hij rond de kantoorschil in `routes.tsx`: zo zit hij op
          `/monteur` niet in de geladen code (AC 2). De poll overleeft de navigatie tussen
          kantoorschermen nog steeds — die layout blijft gemount — en de afrond-toaster
          verschijnt via de `<Toaster>` hierboven in RootShell, net als voorheen. */}
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
